import { AIModelProvider } from 'api/ai';
import clsx from 'clsx';
import {
  AvoSelect,
  AvoSelectItem,
  AvoSelectItembox,
  AvoSelectTrigger,
} from 'components/utils/AvoSelect';
import { Icons } from 'components/utils/Icons';
import { Skeleton } from 'components/utils/Skeleton';
import { StaffOnlyBadgeType, StaffOnlyWrapper } from 'components/utils/StaffOnlyWrapper';
import { Body2 } from 'components/utils/typo';
import { useAIModels } from 'hooks/useAIModels';
import { CheckIcon } from 'lucide-react';

// const reasoningEfforts = ['high', 'medium', 'low'] as const;
// export type ReasoningEffortTypes = (typeof reasoningEfforts)[number];

interface AIModelSelectProps {
  providers?: AIModelProvider[];
  onChange: (model_id: number) => void;
  model_id: number;
}

export const AIModelSelect = ({ providers, onChange, model_id }: AIModelSelectProps) => {
  const { aiModels, isLoading } = useAIModels();
  const modelMap = aiModels?.reduce(
    (acc, model) => {
      acc[model.id] = model.label;
      return acc;
    },
    {} as Record<number, string>
  );
  const onModelSelect = (value: number) => {
    onChange(value);
  };
  return isLoading || !aiModels ? (
    <div className='border-300 rounded border p-2'>
      <Skeleton />
    </div>
  ) : (
    <AvoSelect value={model_id} onChange={onModelSelect}>
      <AvoSelectTrigger className='z-20 flex justify-between gap-1 rounded border border-gray-200 p-2.5 pl-3 focus:bg-white'>
        {({ isOpen }) => (
          <>
            <Body2>{modelMap![model_id]}</Body2>
            <Icons.CaretDown className={clsx('transition-all', isOpen && 'rotate-180')} />
          </>
        )}
      </AvoSelectTrigger>
      <AvoSelectItembox className='z-10 rounded bg-white shadow-04'>
        {aiModels
          .filter((model) => !providers || providers.includes(model.provider))
          .map((model) => {
            const item = (
              <AvoSelectItem value={model.id} className='p-2 hover:bg-primary-300' key={model.id}>
                {({ isSelected }) => (
                  <div className='flex justify-between'>
                    <Body2>{model.label}</Body2>
                    {isSelected && <CheckIcon className='h-5 w-5 text-primary-500' />}
                  </div>
                )}
              </AvoSelectItem>
            );
            return model.is_public ? (
              item
            ) : (
              <StaffOnlyWrapper type={StaffOnlyBadgeType.STAFF} key={model.id}>
                {item}
              </StaffOnlyWrapper>
            );
          })}
      </AvoSelectItembox>
    </AvoSelect>
  );
};
